import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "list"
};
const _hoisted_2 = {
  class: "item"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "下单人：", -1);

const _hoisted_4 = {
  class: "value"
};
const _hoisted_5 = {
  class: "item"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "所属团队：", -1);

const _hoisted_7 = {
  class: "value"
};
const _hoisted_8 = {
  class: "item"
};

const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "下单时间：", -1);

const _hoisted_10 = {
  class: "value"
};
const _hoisted_11 = {
  class: "item"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "分账总额：", -1);

const _hoisted_13 = {
  class: "value"
};
const _hoisted_14 = {
  key: 0,
  class: "item"
};

const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "平台服务费扣减：", -1);

const _hoisted_16 = {
  class: "value"
};
const _hoisted_17 = {
  key: 1,
  class: "item"
};

const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "特殊说明：", -1);

const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "value"
}, "分账时下级团队分账受益人不存在产生的分账金额增加至此账户", -1);

const _hoisted_20 = [_hoisted_18, _hoisted_19];

const _hoisted_21 = /*#__PURE__*/_createTextVNode("关闭");

import { ref, computed, watch } from 'vue';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'detail-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    recordId: [String, Number]
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emits('update:modelValue', val);
      }

    });
    watch(() => props.modelValue, v => {
      if (v) {
        detailData.value = {
          linkMan: '',
          supplierName: '',
          orderCreateTime: '',
          prodInfoList: []
        };
        getDetail();
      }
    });
    const detailData = ref({
      linkMan: '',
      supplierName: '',
      orderCreateTime: '',
      prodInfoList: []
    });

    function getDetail() {
      let params = {
        recordId: props.recordId
      };
      Axios.get('/admin/split/record/detail.json', {
        params
      }).then(res => {
        let {
          success,
          data
        } = res.data;
        if (!success) return;
        detailData.value = data;
      });
    }

    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "详情",
        width: "600px",
        top: "5vh",
        "custom-class": "account-detail-modal"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_21]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString(detailData.value.linkMan), 1)]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString(detailData.value.supplierName), 1)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("span", _hoisted_10, _toDisplayString(detailData.value.orderCreateTime), 1)]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", _hoisted_13, "￥" + _toDisplayString(detailData.value.totalSplitAmount), 1)]), detailData.value.serviceFee ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_hoisted_15, _createElementVNode("span", _hoisted_16, "￥" + _toDisplayString(detailData.value.serviceFee), 1)])) : _createCommentVNode("", true), detailData.value.hasOtherSplitAmount == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20)) : _createCommentVNode("", true), _createVNode(_component_el_table, {
          data: detailData.value.prodInfoList
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "商品名称",
            prop: "prodName"
          }), _createVNode(_component_el_table_column, {
            label: "分账规则",
            prop: "splitRuleText"
          }), _createVNode(_component_el_table_column, {
            label: "分账金额",
            prop: "splitAmount"
          })]),
          _: 1
        }, 8, ["data"])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};